// extracted by mini-css-extract-plugin
module.exports = {"comp":"ListA3_comp__IFkTY"};